var NewsletterWidget = {
  formFields: [
    {name: "type", required: true},
    {name: "email", required: true},
    {name: "accept", required: true},
  ],
  init: function () {
    $('.widget-newsletter form').each(function (i, form) {
      var typesEl = $(form).find('.subscription-types');
      $(form).on('submit', function (evt) {
        evt.preventDefault();
        $(form).find('.form-error').hide();
        var errors = Forms.validateFields(form, NewsletterWidget.formFields);
        if (errors.length === 0) {
          var json = {
            email: form.elements.email.value,
            acceptRules: form.elements.accept,
            types: []
          };
          $(form.elements.type).map(function (i, el) {
            if (el.checked) {
              json.types.push(el.value);
            }
          });
          jQuery.ajax({
            url: "/newsletter/subscribe",
            method: "post",
            data: JSON.stringify(json),
            contentType: 'application/json; charset=utf-8',
            success: function (resp) {
              form.reset();
              if (form.name === "accountSubscribe") {
                window.location.reload();
              } else {
                $('#subscribeSuccess_modal').popup('show');
              }
            }
          });
        }
      });

      $(form).find('.unsubscribe').click(function () {
        jQuery.ajax({
          url: "/newsletter/unsubscribe",
          method: "post",
          data: JSON.stringify({
            type: this.id
          }),
          contentType: 'application/json; charset=utf-8',
          success: function () {
            window.location.reload();
          }
        });
      });

      if (typesEl.length) {
        jQuery.ajax({
          url: "/newsletter/types",
          method: "get",
          contentType: 'application/json; charset=utf-8',
          success: function (resp) {
            typesEl.html("");
            $.each(resp, function (i, item) {
              var html = $(
                '<input type="checkbox" name="type" id="type' + i + '" value="' + item._id + '">' +
                '<label for="type' + i + '">' + item.name + '</label>');
              typesEl.append(html);
            });
          }
        });
      }
    });
  }
};
$(NewsletterWidget.init);

// angular.module('app').controller('SubscribeCtrl', ['$scope', '$http', function ($scope, $http) {
//   var ctrl = $scope.ctrl = this;
//
//   ctrl.closeErrorPopup = function () {
//     $('#error_popup').popup('hide');
//   };
//
//   ctrl.closeAlreadyExistsErrorPopup = function () {
//     $('#already_exists').popup('hide');
//   };
//
//   ctrl.submit = function () {
//     if (!ctrl.acceptRules || !ctrl.email || !ctrl.type || ctrl.type.indexOf(true) === -1) {
//       return $('#error_popup').popup('show');
//     }
//     var types = [];
//     for (var i = 0; i < ctrl.type.length; i++) {
//       if (ctrl.type[i]) {
//         types.push(ctrl.types[i]._id);
//       }
//     }
//     var json = {
//       email: ctrl.email,
//       acceptRules: ctrl.acceptRules,
//       type: types
//     }
//     $http.post('/subscribe', json).then(function (response) {
//       if (response.data && response.data.success) {
//         if (location.href.includes('moja-subskrypcja')) {
//           return location.reload();
//         }
//         $('#success_subscribe').popup('show');
//         ctrl.email = null;
//         ctrl.acceptRules = false;
//         ctrl.type = [];
//       } else if (response.data && response.data.success === false) {
//         $('#already_exists').popup('show');
//       } else {
//         $('#error_popup').popup('show');
//       }
//     }, function (err) {
//       $('#error_popup').popup('show');
//       console.log(err);
//     });
//   };
//
//   ctrl.init = function () {
//     ctrl.type = [];
//     $http.get('/shop/subscribe/getTypes').then(function (response) {
//       if (response.data) {
//         ctrl.types = response.data;
//       } else {
//         ctrl.types = [];
//       }
//     })
//   }
// }]);
